import buttonsStyle from './buttonsStyle';

const confirmPopupStyles = (theme) => ({
  dialogLayout: {
    color: '#fff',
  },
  textAreaWidth: {
    minWidth: 920,
    background: 'none',
    padding: 10,
    color: theme.palette.primary.contrastText,
  },
  textAreaLabel: {
    color: theme.palette.secondary.dark,
  },
  '& .MuiDialog-paperScrollPaper': {
    borderRadius: '10px',
  },
  dialogTitle: {
    color: theme.palette.modalTextColor.color,
    background: theme.palette.modalsContentBg.color,
    minWidth: 540,
    padding: '10px 10px 10px 24px',
    '& h2': {
      display: 'flex',
      alignItems: 'center',
    },
    '@media (max-width: 767px)': {
      minWidth: 'inherit',

    },
  },
  dialogContent: {
    color: theme.palette.secondary.contrastText,
    background: theme.palette.modalsContentBg.color,
    minHeight: 65,
    padding: '8px 24px',
    '& h4': {
      margin: '0px',

    },
    '@media (max-width: 767px)': {
      minWidth: 'inherit',

    },
  },
  dialogAction: {
    background: theme.palette.modalsContentBg.color,
    padding: '0 20px 20px',
  },
  defaultButton: {
    ...buttonsStyle.defaultButton,
    color: '#ffff',
    marginLeft: '14px',
    background: theme.palette.defaultBtnShadow.background,
    '&:hover': {
      background: theme.palette.defaultBtnShadow.backgroundHover,
      color: '#ffff',
      boxShadow: theme.palette.defaultBtnShadow.boxShadow,
    },
  },
  activeButton: {
    width: 'auto',
    '&:hover': {
      background: '#189b54',
      opacity: 0.9,
    },
    '&.Mui-disabled': {
      color: '#fff',
      cursor: 'not-allowed',
      pointerEvents: 'inherit',
      background: '#189b5496',
      borderRadius: '28px',
      '&:hover': {
        background: '#189b5496',
        cursor: 'not-allowed',
      },
    },
    ...buttonsStyle.activeButton,
    color: '#fff',
    background: '#01BD5A',
    borderRadius: '28px',
  },
  rightArrow: {
    position: 'absolute',
    right: 0,
    top: '50%',
    minWidth: 42,
    maxWidth: 42,
    opacity: 0.8,
    borderRadius: '21px 0 0 21px',
    paddingRight: 10,
    background: theme.palette.primary.main,
  },
  leftArrow: {
    position: 'absolute',
    left: 0,
    top: '50%',
    margin: 0,
    minWidth: 42,
    maxWidth: 42,
    opacity: 0.8,
    borderRadius: '0 21px 21px 0',
    paddingLeft: 10,
    background: theme.palette.primary.main,
  },
  fullWidth: {
    width: '100%',
  },
  uploadImg: {
    width: '100%',
    float: 'left',
    height: '100%',
    borderRadius: 0,
  },
  moduleImage: {
    background: '#189b5430',
    marginRight: 10,
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    '& svg': {
      fill: '#189b54',
      width: 22,
      height: 22,
    },
  },
});

export default confirmPopupStyles;
